import React, { Component } from 'react';
import { Select, Modal, Button, DatePicker, message } from 'antd';
import map from 'lodash/map';
import moment from 'moment-timezone';
import chevron from '../../../../Assets/images/chevron.svg';
import CSV from '../../../../Assets/images/csv.png';
import confused from '../../../../Assets/images/confused.png';
import sad from '../../../../Assets/images/sad.png';
import smile from '../../../../Assets/images/smile.png';

const { Option } = Select;


class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_new_ticket: false,
      is_close_ticket: false,
      is_details: false,
      loader: false,
      reson_text: '',
      message_list: [],
      message_replies: [],
      current_message: {},
      review: '',
      reason: [ ],
      new_ticket: {
        reason: '',
        visit_date: null,
        title: '',
        message: '',
      },
      filter: {
        'status': '',
        'priority': '',
        'ordering': '',
      },
      errors: {},
      ownerUuid: null
    }
  }
  componentDidMount = () => {
    // get message list

    this.props.getMessagesList();
    this.props.getReasonList();
    this.setState({
      loader: true
    })
    //Edit Service request
    let is_edit_request = JSON.parse(localStorage.getItem('is_edit_request')) || null;
    if (is_edit_request) {
      let { new_ticket } = this.state;
      new_ticket = Object.assign(new_ticket, { 'reason': 'edit_existing_service' })
      this.setState({
        is_new_ticket: true,
        new_ticket
      });
      localStorage.removeItem('is_edit_request');
    }

    //Edit Service request
    let is_request_one_time = JSON.parse(localStorage.getItem('is_request_one_time')) || null;
    if (is_request_one_time) {
      let { new_ticket } = this.state;
      new_ticket = Object.assign(new_ticket, { 'reason': 'request_one_time_service' })
      this.setState({
        is_new_ticket: true,
        new_ticket
      });
      localStorage.removeItem('is_request_one_time');
    }

    //new ticket request

    let is_new_messages = JSON.parse(localStorage.getItem('is_new_messages')) || null;
    if (is_new_messages && is_new_messages.is_new_messages) {
      this.setState({
        is_new_ticket: true,
      });
      localStorage.removeItem('is_new_messages');
    }
    
    let UserDetails = JSON.parse(localStorage.getItem('userKey')) || null;
    if(UserDetails?.user?.field_offices?.length){
      this.props.checkZipCode({
        uuid: UserDetails?.user?.field_offices?.[0]?.uuid
      });
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 300);
  }



  UNSAFE_componentWillReceiveProps = (props) => {
    let { new_ticket, message_replies } = this.state;
    message.destroy();

    // get message list
    if (Object.keys(props.getMessages.data).length > 0 && props.getMessages.data !== this.props.getMessages.data) {
      this.setState({
        message_list: props.getMessages.data.results
      })
    }
    if (Object.keys(props.getMessages.errors).length > 0 && props.getMessages.errors !== this.props.getMessages.errors) {
      //Display error message here
    }
    //Create new message
    if (Object.keys(props.createdMessage.data).length > 0 && props.createdMessage.data !== this.props.createdMessage.data) {
      // get message list
      this.props.getMessagesList();
      //Get message count
      this.props.getMessagesCount();
      Object.assign(new_ticket, { reason: '', visit_date: null, title: '', message: '' })
      this.setState({ is_new_ticket: false, new_ticket })
    }
    if (Object.keys(props.createdMessage.errors).length > 0 && props.createdMessage.errors !== this.props.createdMessage.errors) {
      //Display error message here
      map(props.createdMessage.errors, (item, i) => {
        message.error(`${i}:::${item}`)
      })
    }

    // message reply
    if (Object.keys(props.messageReply.data).length > 0 && props.messageReply.data !== this.props.messageReply.data) {

      // get message list
      this.props.getMessagesList();
      //Get message count
      this.props.getMessagesCount();
      message_replies.push(props.messageReply.data)
      this.setState({
        replay_message: '',
        message_replies
      })
    }
    if (Object.keys(props.messageReply.errors).length > 0 && props.messageReply.errors !== this.props.messageReply.errors) {
      //Display error message here
    }

    // ticket closed
    if (Object.keys(props.ticketClosed.data).length > 0 && props.ticketClosed.data !== this.props.ticketClosed.data) {
      // get message list
      this.props.getMessagesList();
      //Get message count
      this.props.getMessagesCount();
      this.setState({
        replay_message: '',
        is_close_ticket: false,
        review: '',
        is_details: true
      })
    }
    if (Object.keys(props.ticketClosed.errors).length > 0 && props.ticketClosed.errors !== this.props.ticketClosed.errors) {
      //Display error message here
    }
    // get reason list
    if (Object.keys(props.getReasons.data).length > 0 && props.getReasons.data !== this.props.getReasons.data) {
      this.setState({
        reason: props.getReasons.data.results
      })
    }

    //get ownerUuid
    if (Object.keys(props.zipcodeReducers.data).length > 0 && props.zipcodeReducers.data !== this.props.zipcodeReducers.data) {
      this.setState({
        ownerUuid: props?.zipcodeReducers?.data?.results[0]?.owner?.uuid
      })
    }
    
    this.setState({
      loader: false
    })
  }

  // calulate Date 
  calulateDate = (created_timestamp) => {
    let currentDate = moment();

    if (moment(created_timestamp).isSame(currentDate, "day")) {
      return moment(created_timestamp).fromNow();

    } else if (
      moment(created_timestamp).isSame(
        moment()
          .subtract(1, "days")
          .startOf("day"),
        "d"
      )
    ) {
      return "Yesterday";
    } else {
      return moment(created_timestamp).format("MM-DD-YYYY");
    }
  }
  // convert date time from utc to local time
  UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }

  //renderMessageList
  renderMessage = () => {
    let { message_list } = this.state;
    return map(message_list, (item, key) => {

      return (
        <div className={!item.read_by_customer ? 'trow active' : 'trow'} key={key}>
          <span className="title" onClick={() => {
            this.props.getMessagesCount(); this.props.getMessagesList();

            this.setState({
              loader: true,
              message_replies: message_list[key]['replies'],
              current_message: {
                title: message_list[key]['title'],
                message: message_list[key]['message'],
                uuid: message_list[key]['uuid'],
                reason: message_list[key]['reason'],
                status: message_list[key]['status'],
                assigned_user_details: message_list[key]['assigned_user_details'],
                created_at: message_list[key]['created_at'],
                user_details: message_list[key]['user_details']
              },
              is_details: true

            })

            this.props.closeTicket({ 'uuid': item.uuid, 'read_by_customer': true })
          }}>{item.title}</span>
          {/* <span className={
            item.priority_display.toLowerCase() === 'standard' ? 'priority priority_standard' :
              item.priority_display.toLowerCase() === 'high' ? 'priority priority_high' : 'priority'
          }>{item.priority_display} Priority</span> */}
          <span className={item.status === 'open' ? 'status status_success' : 'status'}>{item.status}</span>
          <span className="time">Created { this.UTCToLocal(item.created_at).fromNow(true)}</span>
        </div>
      )

    })
  }

  // new ticket title and message change
  ticketOnchange = (e) => {
    let { new_ticket } = this.state;
    Object.assign(new_ticket, { [e.target.name]: e.target.value })
    this.setState({
      new_ticket
    })
  }
  
  //ticket dropdown change
  ticketDropdownOnchange = (e,f) => {
    let { new_ticket,ownerUuid } = this.state;
    if(e === "cancel_my_services" ){
      Object.assign(new_ticket, { 'title': "Cancel My Services", 'priority': 3,"follow_up_date":moment().add(1, 'days').format("YYYY-MM-DD"),"status": "open","assigned_user":ownerUuid}); 
    }else{
      if( new_ticket.title === "Cancel My Services"){
      delete new_ticket.title;
      delete new_ticket.priority;
      delete new_ticket.follow_up_date;
      delete new_ticket.status;
      delete new_ticket.assigned_user;
      }
    }
    Object.assign(new_ticket, { 'reason': e, 'reson_text': f.children }); 
    this.setState({ new_ticket });
  }

  //create new ticket

  createNewTicket = (e) => {
    let errors = {}
    e.preventDefault();
    let { new_ticket } = this.state;
    //new ticket api call;

    if (new_ticket.message && new_ticket.title && new_ticket.reason) {
      this.setState({ loader: true, errors: {} })
      this.props.createMessage(new_ticket);
    }
    else {
      if (!new_ticket.message) {
        errors['message'] = 'Message Is Required';
      }
      if (!new_ticket.title) {
        errors['title'] = 'Title Is Required';
      }
      if (!new_ticket.reason) {
        errors['reason'] = 'Reason Is Required';
      }
      this.setState({
        errors
      })
    }


  }
  // replay on ticket
  replayToTicket = () => {
    let { replay_message, current_message } = this.state;
    if (replay_message) {
      this.setState({
        loader: true
      })
      this.props.messageReplay({ 'message': replay_message, 'parent_uuid': current_message.uuid })
    }

  }
  renderReplayDate = (date) => {
    let reply_time = '';
    reply_time = `${moment(date).format('MM/DD/YYYY')} at ${moment(date).format('hh:mm a')}`;
    return reply_time
  }

  //renderMessageREplay
  renderMessageReplay = () => {
    let { message_replies } = this.state;

    return map(message_replies, (item, i) => {

      if (!item.is_internal) {
        return (
          <div className={message_replies[message_replies.length - 1].uuid === item.uuid && message_replies[message_replies.length - 1]['user_details'].role.length === 0 ? 'msg-tbl-block active' : 'msg-tbl-block'} key={i}>
            <div className="mrow">
              <div className="mbody">
                <div className="mhead">
                  <div className="user-info">
                    {item.user_details.photo ?
                      <figure className="profile-wrap">
                        <img src={item.user_details.photo} alt="" />
                      </figure> : ''}

                    <div className="uname">
                      <div className="title-head">
                        <span className="name">
                          <React.Fragment>
                            {item?.user_details?.first_name || item.user_details.first_name ? `${item?.user_details?.first_name} ${item?.user_details?.last_name} Replied` : 'No user found '}</React.Fragment>
                          <p className="desc">{item?.user_details?.description}</p>
                        </span>
                        {/* <span className="time">{this.renderReplayDate(item.created_at)}</span> */}
                      </div>
                      <small>{item.description}</small>
                    </div>
                  </div>
                </div>
                <p className="mb-0">{item.message}</p>
              </div>
            </div>
          </div>
        )
      }

    })
  }
  // close Ticket
  closeTicket = () => {
    let { current_message, review } = this.state;

    Object.assign(current_message, { 'status': false })
    this.setState({ loader: true, current_message })
    this.props.closeTicket({ 'uuid': current_message.uuid, 'status': 'closed', 'satisfaction': review })
  }
  //Add Review
  addReview = (e) => {
    this.setState({
      review: e
    })
  }

  filetMessage = () => {
    let { filter } = this.state;
    this.props.getMessagesList(filter);
    this.setState({ loader: true })
  }


  render() {
    let {
      is_new_ticket, is_close_ticket, is_details, new_ticket,
      loader, current_message, reason, replay_message, review,
      filter, message_list, errors
    } = this.state;
    return (
      <div className="message_wrapper">
        <div className={is_details ? 'd-none' : 'container'}>
          <div className="row">
            <div className="col-md-12">

              <div className="filter">
                <ul className={message_list.length > 0 ? 'filter_list' : 'filter_list disable_filter'}>
                  <li>
                    <Select
                      className="sort_by"
                      value={filter.ordering}
                      onChange={(e) => { Object.assign(filter, { 'ordering': e }); this.setState({ filter }, () => { this.filetMessage() }); }}
                      suffixIcon={<img src={chevron} alt="" />}
                      virtual={false}
                    >
                      <Option value="">All</Option>
                      <Option value="created_at"><i className="las la-long-arrow-alt-up sort_by_icon"></i>Created at</Option>
                      <Option value="-created_at"><i className="las la-long-arrow-alt-down sort_by_icon"></i>Created at</Option>
                    </Select>
                  </li>
                  <li className="hide-md">
                    <Select
                      className="status"
                      value={filter.status}
                      suffixIcon={<img src={chevron} alt="" />}
                      onChange={(e) => { Object.assign(filter, { 'status': e }); this.setState({ filter }, () => { this.filetMessage() }); }}
                      virtual={false}
                    >
                      <Option value="">All</Option>
                      <Option value="open">Open</Option>
                      <Option value="closed">Closed</Option>
                    </Select>
                  </li>
                  {/* <li>
                    <Select
                      className="priority"
                      value={filter.priority}
                      onChange={(e) => { Object.assign(filter, { 'priority': e }); this.setState({ filter }, () => { this.filetMessage() }); }}
                      suffixIcon={<img src={chevron} alt="" />} >
                      <Option value="">All</Option>
                      <Option value="4">Standard</Option>
                      <Option value="3">High</Option>
                    </Select>
                  </li> */}
                  <li className="hide-md">
                    <button className="export_scv btn"
                      onClick={() => {
                        this.props.getCSVData({ 'format': 'csv', 'time_offset' :  -new Date().getTimezoneOffset() });
                      }}>
                      <img src={CSV} alt="" style={{ 'height': '20px' }} />
                    </button>
                  </li>
                </ul>
                <button className="btn btn--secondary" onClick={() => { this.setState({ is_new_ticket: true }) }}><span className="hide-md">Add New Ticket </span><b className="show-md"><i className="las la-plus"></i></b></button>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              {message_list.length > 0 ?
                <div className="message_list">
                  <div className="msg-tbl-block">
                    {this.renderMessage()}
                  </div>
                </div>
                : <div className="blank_message_list">
                  <h4>You have no recent messages.</h4>
                  <span className="text-center">Add a new ticket to raise an issue or ask any queries to our team.</span>
                </div>}
            </div>
          </div>
        </div>

        {/* Ticket detail page starts here*/}
        <div className={is_details ? 'container' : 'd-none'}>
          <div className="row">
            <div className="col-md-12">
              <div className="breadcrumb">
                <ul>
                  <li><a href="/#" onClick={(e) => { e.preventDefault(); this.setState({ is_details: false, loader: true }); this.props.getMessagesCount(); this.props.getMessagesList(); }}>My Tickets</a></li>
                  <li><a href="/#" onClick={(e) => { e.preventDefault(); }}>{current_message && current_message.title}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className={is_details ? 'container' : 'd-none'}>
          <div className="row">
            <div className="col-md-12">
              <div className="message_list mt-0 ticket_detail">
                <div className="msg-tbl-block">
                  <div className="mrow">
                    <div className="mhead-row">
                      <div className="title">{current_message.title}</div>
                      <div className="title-head">
                        {current_message.reason ? <b>
                          {
                            map(reason, (item) => {
                              if (item?.dis_name === current_message.reason) {
                                return item?.reason
                              }
                            })

                          }
                        &nbsp;&nbsp;&nbsp;&nbsp;·&nbsp;&nbsp;&nbsp;&nbsp;</b> : '· ------.'}


                        {current_message && current_message.assigned_user_details ?
                          <React.Fragment>
                            {`${current_message?.assigned_user_details?.first_name} ${current_message?.assigned_user_details?.last_name} Assigned`}
                          </React.Fragment> : 'Waiting for Assigning'}
                      </div>
                    </div>
                    <div className="mbody">

                      <div className="mhead">
                        <div className="user-info">
                          <div className="uname">
                            <div className="title-head">
                              {current_message?.user_details?.photo ?
                                <figure className="profile-wrap">
                                  <img src={current_message.user_details.photo} alt="" />
                                </figure> : ''}
                              <span className="name">{`${current_message.user_details?.first_name && current_message.user_details?.first_name} ${current_message.user_details?.last_name && current_message.user_details?.last_name}`} Replied
                                <p className="desc">{`${current_message.user_details?.description || ''}`} </p>
                              </span>

                              {/* <span className="time">{`${moment(current_message.created_at).format('MM/DD/YYYY')} at ${moment(current_message.created_at).format('hh:mm A')}`}

                              </span> */}
                            </div>

                          </div>
                        </div>
                      </div>
                      <p className="mb-0">{current_message.message}</p>
                    </div>
                  </div>
                </div>
                {this.renderMessageReplay()}
                {current_message.status === 'open' ?
                  <div className="reply-form">
                    <h6>Reply to ticket</h6>
                    <textarea
                      placeholder="Add your message here"
                      className="form--control"
                      name="replay_message"
                      onChange={(e) => { this.setState({ 'replay_message': e.target.value }) }}
                      value={replay_message}
                    ></textarea>
                    <div className="btn-block">
                      <span className="hide-md close-txt">Is your ticket resolved? <a href="/#" onClick={(e) => { e.preventDefault(); this.setState({ is_close_ticket: true }) }}><u>Close this ticket.</u></a></span>
                      <button type="button" className="btn btn--secondary" disabled={replay_message ? false : true} onClick={(e) => { this.replayToTicket(e) }}>Reply to Ticket</button>
                    </div>

                  </div>
                  : ''}

              </div>
              <div className="btn-block">
                <span className="show-md mb-30 close-txt">Is your ticket resolved? <a href="/#" onClick={(e) => { e.preventDefault(); this.setState({ is_close_ticket: true }) }}><u>Close this ticket.</u></a></span>
              </div>
            </div>
          </div>
        </div>
        {/* Ticket detail page ends here*/}
        <Modal
          className="message_popup"
          visible={is_new_ticket}
          footer={[
            <Button key="cancel"
              className="btn btn-outline--primary"
              onClick={() => {
                this.setState({
                  is_new_ticket: false, new_ticket: {
                    reason: '',
                    visit_date: null,
                    title: '',
                    message: '',
                  }
                })
              }} >Close</Button>,
            <Button
              key="submit"
              className="btn btn--secondary"
              // disabled={new_ticket.title && new_ticket.message ? false : true}
              onClick={(e) => { this.createNewTicket(e) }}>Create Ticket</Button>
          ]}
        >
          <div className="moday_body">
            <h6 className="modal-head">Add New Ticket</h6>
            <div className="modal-form">
              <form>
                <div className="form-group">
                  <input type="text" className="form--control"
                    value={new_ticket.title || ''}
                    name="title"
                    onChange={(e) => { this.ticketOnchange(e) }}
                    readOnly={ new_ticket.reason === "cancel_my_services"?true:false }
                    placeholder="Add your Ticket Title" />
                  {errors['title'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['title']}</label> : ''}
                </div>
                <div className="form-group">
                  <textarea
                    className="form--control"
                    placeholder="Add your message here"
                    value={new_ticket.message || ''}
                    name="message"
                    onChange={(e) => { this.ticketOnchange(e) }}

                  > </textarea>
                  {errors['message'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['message']}</label> : ''}
                </div>
                <div className="form-group d-flex sm-flex-col">
                  <div className="halfitem">
                    <Select
                      className="sort_by"
                      placeholder="Reason"
                      value={new_ticket.reason || undefined}
                      onChange={(e, f) => { this.ticketDropdownOnchange(e,f);}}
                      suffixIcon={<img src={chevron} alt="" />}
                      virtual={false}
                    >
                      {map(reason, (item, i) => {
                        return (<Option value={item?.dis_name} key={i}>{item?.reason}</Option>)
                      })}

                    </Select>
                    {errors['reason'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['reason']}</label> : ''}
                  </div>
                  <div className="halfitem">
                    {/* <Select
                      className="sort_by"
                      placeholder="Visit Date (optional)"
                      onChange={(e) => { Object.assign(new_ticket, { 'visited': e }); this.setState({ new_ticket }) }}
                      suffixIcon={<img src={chevron} alt="" />}
                    >
                      <Option value="1">Visit Date (optional)</Option>
                      <Option value="2">2</Option>
                      <Option value="3">3</Option>
                    </Select> */}

                    {/* use date picker instead of drop down  until field tech module not completed  */}
                    <DatePicker
                      className="form--control date_picker"
                      format="MM/DD/YYYY"
                      inputReadOnly
                      disabledDate={(current) => { return current && current > moment().endOf('day'); }}
                      value={new_ticket.visit_date ? moment(new_ticket.visit_date) : undefined}
                      onChange={(e) => {
                        Object.assign(new_ticket, { 'visit_date': moment(e._d).format("YYYY-MM-DD") });
                        this.setState({ new_ticket });
                      }}
                      allowClear={false}
                      dropdownClassName="dog_date_dropdown"
                      placeholder="Visit Date (optional)" />
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-info">
              <strong>Get help now</strong>
              <span><strong>Mon - Fri:</strong> 8:30am to 9:00pm (ET)</span>
              <span><strong>Sat:</strong> 9:00am to 5:00pm (ET)</span>
              <span><strong>Sun:</strong> 10:00am - 4:00pm (ET)</span>
              <br />
              <strong>1-800-366-3922</strong>
            </div>
          </div>
        </Modal>
        {/* review Pop up */}
        <Modal
          className="message_popup"
          visible={is_close_ticket}
          footer={[
            <Button key="cancel" className="btn btn-outline--primary" onClick={() => { this.setState({ is_close_ticket: false, review: '' }) }} >Cancel</Button>,
            <Button key="submit" className="btn btn--secondary" disabled={review ? false : true} onClick={() => { this.closeTicket() }}>Close Ticket</Button>
          ]}
        >
          <div className="moday_body">
            <h6 className="modal-head">Do you wish to close this ticket?</h6>
            <div className="modal-info">
              <strong>Are you satisfied with your support? </strong>
              <span>You can choose to close this ticket now if you are satisified with the customer support, and got the answers you needed.</span>
              <br />
              <span>Please rate your customer satisfaction below. </span>
            </div>
            <div className="ratings">
              <figure>
                <img src={smile} alt="rate" className={review === 'happy' || review === '' ? '' : 'disable'} onClick={() => { this.addReview('happy') }} />
              </figure>
              <figure>
                <img src={confused} alt="rate" className={review === 'neutral' || review === '' ? '' : 'disable'} onClick={() => { this.addReview('neutral') }} />
              </figure>
              <figure>
                <img src={sad} alt="rate" className={review === 'sad' || review === '' ? '' : 'disable'} onClick={() => { this.addReview('sad') }} />
              </figure>
            </div>
            <div className="review-txt">
              <div className={review === 'happy' || review === 'cc' ? '' : 'd-none'}>
                <strong>We are so happy that you were satisfied with your support!</strong>
                <span>You can now close your ticket.</span>
              </div>
              <div className={review === 'neutral' || review === 'cc' ? '' : 'd-none'}>
                <strong>If there is anything else we can help you with, please don’t hesitate to get in touch! </strong>
                <span>You can now close your ticket.</span>
              </div>
              <div className={review === 'sad' || review === 'cc' ? '' : 'd-none'}>
                <strong>We are deeply saddened that you were not satisfied with your support. Please get in touch via phone to discuss your matter further.</strong>
                <span>You can now close your ticket. </span>
              </div>
            </div>
          </div>
        </Modal>

        {
          loader ?
            <div className='loader_wrapper'>
              <div className='loader07'></div>
            </div>
            : ''
        }
      </div>

    );
  }
}

export default Messages;